import axios from 'axios';
import config from '../config';
import { getUserToken } from '../utils/helper';

export const GET_USER_CONVERSATIONS = 'GET_USER_CONVERSATIONS';
export const GET_USER_CONVERSATIONS_SUCCESS = 'GET_USER_CONVERSATIONS_SUCCESS';
export const GET_USER_CONVERSATIONS_FAIL = 'GET_USER_CONVERSATIONS_FAIL';
export const GET_USER_CONVERSATIONS_RESET = 'GET_USER_CONVERSATIONS_RESET';

export const getUserConversations = (params) => {
	return {
		type: GET_USER_CONVERSATIONS,
		params,
	};
};

export const getUserConversationsSuccess = (response) => {
	return {
		type: GET_USER_CONVERSATIONS_SUCCESS,
		response,
	};
};

export const getUserConversationsFail = (response) => {
	return {
		type: GET_USER_CONVERSATIONS_FAIL,
		response,
	};
};

export const getUserConversationsReset = () => {
	return {
		type: GET_USER_CONVERSATIONS_RESET,
	};
};

export const getUserConversationsApi = (data) => {
	return (dispatch) => {
		dispatch(getUserConversations());
		axios
			.get(`${config.api.base_url}/voice-assistance/conversations`, {
				params: data,
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const conversationsData = response.data;
				dispatch(getUserConversationsSuccess(conversationsData));
			})
			.catch((error) => {
				const errorMsg = error.response
					? error.response.data
					: error.message;
				dispatch(getUserConversationsFail(errorMsg));
			});
	};
};
